import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardWidgetConfigurationInterface } from 'dashboard/interfaces/dashboard-widget-configuration.interface';
import type { EChartsCoreOption } from 'echarts/core';
import { ListingStatusEnum } from 'shared/constants/listing-statuses';
import { StorageService } from 'shared/services';

const pieChartListingStatusMapping: { [key: string]: ListingStatusEnum | ListingStatusEnum[] } = {
    live: ListingStatusEnum.LIVE,
    draft: ListingStatusEnum.DRAFT,
    publishingFailures: ListingStatusEnum.FAILURES,
    returnedToEditor: [ListingStatusEnum.REJECTED, ListingStatusEnum.REJECTED_WITH_COMMENTS],
    waitingForApproval: ListingStatusEnum.APPROVAL,
    neverLive: ListingStatusEnum.NEW,
};

@Component({
    selector: 'app-pie-chart-dashboard-widget',
    templateUrl: './pie-chart-dashboard-widget.component.html',
    styleUrls: ['./pie-chart-dashboard-widget.component.scss', '../dashboard/dashboard.component.scss'],
    standalone: false,
})
export class PieChartDashboardWidgetComponent implements OnChanges {
    @Input() dashboardWidgetConfiguration?: DashboardWidgetConfigurationInterface;

    public pieChartOptions: EChartsCoreOption = {};

    constructor(
        private storageService: StorageService,
        private router: Router,
    ) {}

    public ngOnChanges(): void {
        if (this.dashboardWidgetConfiguration !== undefined && this.dashboardWidgetConfiguration.data?.length > 0) {
            this.generatePieChart();
        }
    }

    protected onLegendEvent(event: any) {
        const legendItem = this.dashboardWidgetConfiguration?.data?.find((legendItem) => legendItem.name === event?.name);

        if (legendItem !== undefined) {
            this.onChartEvent({ data: legendItem });
        }
    }

    protected generatePieChart() {
        this.pieChartOptions = {
            color: ['#039855', '#FEC84B', '#F97066', '#5E8DB7', '#667085', '#D0D5DD'],
            legend: {
                align: 'left',
                left: 270,
                top: 54,
                data: this.dashboardWidgetConfiguration?.labels,
                orient: 'vertical',
                selectorPosition: 'end',
                itemHeight: 8,
                itemWidth: 8,
                itemGap: 8,
                icon: 'circle',
                textStyle: {
                    fontSize: 14,
                    fontFamily: 'Lato',
                    lineHeight: 20,
                    color: '#475467',
                },
            },
            tooltip: {
                trigger: 'item',
                formatter: '{d}% <br/> {b}',
                borderRadius: 4,
                borderColor: '#1D2939',
                backgroundColor: '#1D2939',
                textStyle: {
                    color: '#FFFFFF',
                },
            },
            series: [
                {
                    type: 'pie',
                    name: this.dashboardWidgetConfiguration?.title,
                    data: this.dashboardWidgetConfiguration?.data,
                    top: 0,
                    left: 0,
                    center: [130, 140],
                    width: 280,
                    height: 280,
                    label: {
                        show: false,
                    },
                    labelLine: {
                        length: 0,
                    },
                },
            ],
        };
    }

    protected onChartEvent(event: any) {
        if (!pieChartListingStatusMapping[event.data?.extraData]) {
            return;
        }

        let extraData = pieChartListingStatusMapping[event.data?.extraData];

        if (!Array.isArray(extraData)) {
            extraData = [extraData] as ListingStatusEnum[];
        }

        const listingFilterJSON: any = {
            listingStatus: {
                values: extraData,
                filterType: 'set',
            },
        };

        this.storageService.setInSession('FilterListingsGridService', listingFilterJSON);

        this.router.navigate(['/listings']);
    }
}
